<template>
  <div>
    <review stage="2" auditType="1" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "secondReview",
    components:{review},
  }
</script>